import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import { Trans, withTranslation } from 'react-i18next';
import moment from 'moment-timezone';

import {
  Button,
  Container,
  Dropdown,
  Menu,
  Divider,
  Header,
  Icon,
} from 'semantic-ui-react';
import config from '../../../config';
import { flashErrorMessage } from '../../actions/flash';
import NavBar from '../../components/NavBar';
import { BookingsByStatus, UsersBookings, BranchBookings, ProjectUnitsByStatus, DelistReasonsByStatus } from '../../components/Reports';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import { serverRequestGet } from '../../actions/fetchM';
import { routes } from './navigations';

moment.locale('en-gb');

class Reports extends Component {
  static propTypes = {
    id: PropTypes.string,
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    auth: PropTypes.shape({
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
    }),
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })
  static getPropsToState = (props) => {
    const data = props.data || {};
    const loading = false;
    const menuIsTab = window.innerWidth <= 590;
    return {
      data,
      loading,
      menuIsTab,
    };
  }
  constructor(props) {
    super(props);
    const state = Reports.getPropsToState(props);
    this.state = {
      projectCurrencies: [],
      ...state,
    };
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
    this.fetchProjectCurrencies(this.props.params.id);
  }
  componentWillReceiveProps(nextProps) {
    const state = Reports.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  getValueName = (value, arr) => {
    const valueName = arr.find(vn => vn.value === value);
    if (valueName && valueName.name) {
      return valueName.name;
    }
    return '';
  }
  async fetchProjectCurrencies(projectId) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    try {
      const response = await serverRequestGet(
        `/projects/${projectId}/currency/`,
        store,
      );
      if (response.error) {
        await store.dispatch(flashErrorMessage({ message: response.message }));
        return;
      }
      await this.setLoading(false);
      this.setState({
        projectCurrencies: response.data || [],
      });
    } catch (e) {
      Bugsnag.notifyException(e);
      await this.setLoading(false);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
    }
  }
  hasAccess(check = false) {
    if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
      return true;
    }
    return check;
  }
  handleMenu = (e, { value }) => {
    const { store } = this.context;
    if (value.includes(config.get('bookApiURL')) || value.includes(config.get('salesChartURL'))) {
      e.preventDefault();
      const winObj = window.open(value, '_blank');
      winObj.opener = null;
    } else {
      store.dispatch(replace(value));
    }
  }
  handleResize = () => {
    const state = {};
    const menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== this.state.menuIsTab) {
      state.menuIsTab = menuIsTab;
    }
    const unitLayoutResize = window.innerWidth < 768;
    if (unitLayoutResize !== this.state.unitLayoutResize) {
      state.unitLayoutResize = unitLayoutResize;
    }
    const galleryIsTab = window.innerWidth > 425;
    if (galleryIsTab !== this.state.galleryIsTab) {
      state.galleryIsTab = galleryIsTab;
    }
    const locationResize = window.innerWidth <= 375;
    if (locationResize !== this.state.locationResize) {
      state.locationResize = locationResize;
    }
    this.setState({ ...state });
  }
  render() {
    const { pathname } = this.props.location;
    const { data, projectCurrencies } = this.state;
    const { t } = this.props;
    const links = routes(this.props.id, data, true, false, this.props.auth).map(l => ({
      ...l,
      text: t(l.text),
    }));
    return (
      <Container>
        <NavBar
          links={
            this.state.menuIsTab ?
              <Dropdown
                item
                selectOnBlur={false}
                options={links}
                onChange={this.handleMenu}
                value={pathname}
              />
            : links.map((link, key) => (
              <Menu.Item
                key={key}
                name={link.text}
                content={link.text}
                active={pathname === link.value}
                onClick={e => this.handleMenu(e, link)}
              />
            ))
          }
          rightNav={this.hasAccess() ?
            <Menu.Item fitted>
              <Button
                as={Link}
                primary
                content={t('Edit', { ns: TRANSLATION_FILES.translation })}
                disabled={this.state.loading}
                to={`/projects/${this.props.id}/edit/`}
              />
            </Menu.Item> : null
          }
        />
        <Divider horizontal>
          <Trans ns={TRANSLATION_FILES.screens}>
            Project Unit Reports ({{ name: data.name }})
          </Trans>
        </Divider>
        <Header as="h3">
          <Icon name="chart bar" />
          <Header.Content>
            {t('Project Unit Statuses')}
            <Header.Subheader>
              {t('Units by statuses')}
            </Header.Subheader>
          </Header.Content>
        </Header>
        <ProjectUnitsByStatus
          projectCurrencies={projectCurrencies}
          projectID={this.props.id}
          location={this.props.location}
          headerColor="blue"
          barChart
        />
        <br />
        <Header as="h3">
          <Icon name="list" />
          <Header.Content>
            {t('Delist Reasons')}
            <Header.Subheader>
              {t('Delisted units by reason')}
            </Header.Subheader>
          </Header.Content>
        </Header>
        <DelistReasonsByStatus
          projectCurrencies={projectCurrencies}
          projectID={this.props.id}
          location={this.props.location}
          headerColor="blue"
          barChart
        />
        <br />
        <Divider horizontal>
          <Trans ns={TRANSLATION_FILES.screens}>
            Bookings Reports ({{ name: data.name }})
          </Trans>
        </Divider>
        <Header as="h3">
          <Icon name="chart bar" />
          <Header.Content>
            {t('Booking Statuses')}
            <Header.Subheader>
              {t('Bookings by statuses')}
            </Header.Subheader>
          </Header.Content>
        </Header>
        <BookingsByStatus
          projectCurrencies={projectCurrencies}
          projectID={this.props.id}
          location={this.props.location}
          headerColor="blue"
          barChart
        />
        <Header as="h3">
          <Icon name="list" />
          <Header.Content>
            {t('User Bookings')}
            <Header.Subheader>
              {t('Bookings by user and booking status')}
            </Header.Subheader>
          </Header.Content>
        </Header>
        <UsersBookings
          projectCurrencies={projectCurrencies}
          projectID={this.props.id}
          location={this.props.location}
          headerColor="blue"
        />
        <Header as="h3">
          <Icon name="list" />
          <Header.Content>
            {t('Business Unit Bookings')}
            <Header.Subheader>
              {t('Bookings by business unit and booking status')}
            </Header.Subheader>
          </Header.Content>
        </Header>
        <BranchBookings
          projectCurrencies={projectCurrencies}
          projectID={this.props.id}
          location={this.props.location}
          headerColor="blue"
        />
      </Container>
    );
  }
}

export default withTranslation(namespaces)(connect(Reports.mapStateToProps)(Reports));



// WEBPACK FOOTER //
// ./src/containers/Project/Reports.jsx